import script from "./InputFile.vue?vue&type=script&setup=true&lang=js"
export * from "./InputFile.vue?vue&type=script&setup=true&lang=js"

import "./InputFile.vue?vue&type=style&index=0&id=f6125476&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6125476"]])

export default __exports__